module.exports = __webpack_public_path__ + "img/horizontal_3_6_9006.1ef04087.png";